// @flow
import * as React from "react";
import { Transition } from "react-transition-group";

import type { TransitionProps, StyleProps } from "./";

type Props = {
  ...TransitionProps,
  timeout: number,
  defaultStyles: StyleProps,
  transitionStyles: {
    entering?: StyleProps,
    entered?: StyleProps,
    exiting?: StyleProps,
    exited?: StyleProps,
    unmounted?: StyleProps
  }
};

function TransitionWrapper({
  timeout,
  children,
  defaultStyles,
  transitionStyles,
  ...props
}: Props) {
  if (typeof children === "function") {
    return (
      <Transition timeout={timeout} mountOnEnter unmountOnExit {...props}>
        {state =>
          children({
            style: {
              ...defaultStyles,
              ...transitionStyles[state]
            }
          })
        }
      </Transition>
    );
  }

  return null;
}

export default TransitionWrapper;



// WEBPACK FOOTER //
// ./src/components/common/Animations/Transition.js